export default __webpack_public_path__ + "static/media/dell.2e97355c.jpg";